import { userManagementRoute } from './../../core/routing/route-names';
import { Router, Event, NavigationEnd, ActivatedRoute } from '@angular/router';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class PreventShrinkService {

  public preventShrink = false;

  private preventShrinkPages: string[] = [
    userManagementRoute.toLocaleLowerCase()
  ];

  constructor(private router: Router, private activatedRoute: ActivatedRoute) {
    this.router.events.subscribe((event: Event) => {
      if (event instanceof NavigationEnd) {
        this.preventShrink = false;
        const navigationEnd = event as NavigationEnd;
        const url = navigationEnd.url.toLocaleLowerCase();
        this.preventShrinkPages.forEach(page => {
          const index = url.indexOf(page);
          if (index !== -1 && ((url.length - index) === page.length || url[index + page.length] === '?')) {
            this.preventShrink = true;
          }
        });
      }
    });
  }
}
